var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.594,
    height: 29.25,
    viewBox: "0 0 25.594 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0V29.25H25.594V14.625H10.969V0ZM14.625,0V10.969H25.594ZM3.656,7.313H7.313v3.656H3.656Zm0,7.313H7.313v3.656H3.656Zm0,7.313H18.281v3.656H3.656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabDocument);
export default __webpack_public_path__ + "static/media/tab-document.507edcce4f4431ae92e1f94be720afa2.svg";
export { ForwardRef as ReactComponent };